module.exports = __webpack_public_path__ + "static/media/legende_confirmed_white.3ca7b2cb.svg";